export default "__VITE_ASSET__CHwVCj3c__"